import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef } from 'react';
import defaultStyles from './styles/Button.module.scss.js';
import { jsx } from 'react/jsx-runtime';

const ButtonGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    children,
    dataTestId
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const testProps = {
    'data-test-id': dataTestId
  };
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: clsx(styles.group),
    ...testProps,
    children: children
  });
});
ButtonGroup.displayName = 'ButtonGroup';

export { ButtonGroup };
